import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'manage-prospect-details',
    templateUrl: './prospect-details.component.html'
})
export class ManageProspectDetailsComponent {
    constructor(private fb: FormBuilder) {}

    public formGroup: FormGroup = this.fb.group({});
}
